import React from "react";
import { useParams, Link } from "react-router-dom";
import { reviews } from "../data/reviews";

function ReviewDetails() {
  const { id } = useParams();
  const review = reviews.find(r => r.id === parseInt(id));

  if (!review) return <div className="container-main"><h2>Test non trouvé</h2></div>;

  return (
    <div className="review-detail-page">
      <div className="review-hero">
        <img src={review.image} alt={review.title} className="hero-bg" />
        <div className="hero-overlay">
          <div className="hero-content">
            <Link to="/reviews" className="back-link">← Retour aux tests</Link>
            <h1>{review.title}</h1>
            <div className="big-rating">{review.rating}<span>/20</span></div>
          </div>
        </div>
      </div>

      <div className="review-container">
        <section className="verdict-box">
          <h3>L'avis de GamePulse HQ</h3>
          <p className="verdict-text">{review.verdict}</p>
        </section>

        <div className="pros-cons-grid">
          <div className="pros-card">
            <h4>✅ Points forts</h4>
            <ul>
              {review.pros.map((pro, index) => <li key={index}>{pro}</li>)}
            </ul>
          </div>
          <div className="cons-card">
            <h4>❌ Points faibles</h4>
            <ul>
              {review.cons.map((con, index) => <li key={index}>{con}</li>)}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReviewDetails;